





















// @ is an alias to /src
import Vue from 'vue';

import MotionSearchItem from '@/components/MotionSearchItem.vue';

export default Vue.extend({
  name: 'tournamentInstance',
  props: {
    tournamentInst: {},
  },
  data() {
    return {
      viewRounds: false,
    };
  },
  components: {
    MotionSearchItem,
  },
  methods: {
  },
});
